var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from '@chakra-ui/react';
import { rem } from 'polished';
import { useState, useEffect } from 'react';
import { retrieveBorderSvg } from '../../../services/utils';
export const TextBox = (_a) => {
    var { primaryText = undefined, secondaryText = undefined, borderColor, variant, containerWidth = 'fit-content', primaryTextFontSize = 'md', primaryTextFontWeight = '700', secondaryTextFontSize = 'sm', secondaryTextFontWeight = '400', backgroundColor, textColor = 'text' } = _a, props = __rest(_a, ["primaryText", "secondaryText", "borderColor", "variant", "containerWidth", "primaryTextFontSize", "primaryTextFontWeight", "secondaryTextFontSize", "secondaryTextFontWeight", "backgroundColor", "textColor"]);
    const [borderSVG, setBorderSVG] = useState('');
    useEffect(() => {
        if (variant === 'alicia') {
            const encodedBackgroundImage = retrieveBorderSvg(borderColor !== null && borderColor !== void 0 ? borderColor : '#B5C9FF', false);
            setBorderSVG(encodedBackgroundImage);
        }
        else {
            setBorderSVG('');
        }
    }, [borderColor, variant]);
    return (_jsxs(Box, Object.assign({}, props, { display: "block", p: variant === 'primary' || variant === 'secondary' ? 6 : 10, position: "relative", backgroundRepeat: "no-repeat", backgroundSize: "contain", width: containerWidth, sx: {
            backgroundImage: variant === 'alicia'
                ? `data:image/svg+xml;base64,${borderSVG}`
                : 'transparent',
            borderColor: variant === 'alicia' || variant === 'secondary'
                ? 'none'
                : borderColor !== null && borderColor !== void 0 ? borderColor : 'blackLi',
            borderWidth: variant === 'alicia' || variant === 'secondary' ? '0' : rem(1),
            borderBlockStyle: 'solid',
            backgroundColor: variant === 'primary' || variant === 'secondary' ? backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'transparent' : "transparent",
            borderRadius: variant === 'primary' || variant === 'secondary' ? rem(20) : 0,
        } }, { children: [primaryText && (_jsx(Text, { fontSize: primaryTextFontSize, fontWeight: primaryTextFontWeight, color: textColor, dangerouslySetInnerHTML: {
                    __html: primaryText,
                } })), secondaryText && (_jsx(Text, { fontSize: secondaryTextFontSize, fontWeight: secondaryTextFontWeight, mt: primaryText ? 3 : 0, color: textColor, dangerouslySetInnerHTML: {
                    __html: secondaryText,
                } }))] })));
};
//# sourceMappingURL=TextBox.js.map